import React from 'react';
import { isEmpty } from '../../core/util';
import styles from './styles.css';

const IndirectRolloverConfirmation = ({ appState }) => {
  const {
    store: {
      loadedData: { remittanceFormURL }
    }
  } = appState;

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3>Mail a check</h3>
          <p>
            To fund your account, print this form and mail your check. <br />
          </p>
          <p>
            NOTE: Generally, once you receive your check, you have 60 days to
            send it in to avoid current taxation on that amount.
            <br />
          </p>
          <p>Send to:</p>
          <p>
            <span className="address">
              T. Rowe Price <br />
              P.O. Box 17300 <br />
              Baltimore, MD 21297-1300 <br />
            </span>
          </p>
          {isEmpty(remittanceFormURL) ? (
            <div className="bouncing-transfer-form-text">
              Making your form. please wait...
            </div>
          ) : (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={remittanceFormURL}>
              Download check form
            </a>
          )}
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default IndirectRolloverConfirmation;
